import React, { useCallback, useMemo } from 'react';
import { ActionsBar, Button, IconButton_IconSizes, Section } from '@ydistri/ds';
import ScopeDefinition from './ScopeDefinition';
import { ViewMode } from './scopeUtilsLib';
import { MdEdit, MdOpenInNew } from 'react-icons/md';
import { useMainScope } from './useMainScope';
import { useOpenScopeModal } from './useOpenScopeModal';
import SalesNoticeButton from './SalesNoticeButton';
import { AvailableModals, openModal } from '../../Modals/modalSlice';
import { useAppDispatch } from '../../../store';
import useIsConfigurationEditable from '../../../hooks/useIsConfigurationEditable';
import { useTemplateOrCalculationWithValue } from '../../../hooks/useTemplateOrCalculationWithValue';

const PlaygroundDefinition: React.FC = () => {
  const dispatch = useAppDispatch();
  const scope = useMainScope();
  const openModalHandler = useOpenScopeModal(scope);
  const templateOrCalculation = useTemplateOrCalculationWithValue();
  const isConfigurationEditable = useIsConfigurationEditable();

  const openStoreOverviewModalHandler = useCallback(() => {
    dispatch(openModal({ type: AvailableModals.STORE_OVERVIEW, data: undefined }));
  }, [dispatch]);

  const headerActions = useMemo(() => {
    return (
      <ActionsBar moveToRight={true}>
        <SalesNoticeButton />
        <Button
          $colorVariant="ghost"
          onClick={openStoreOverviewModalHandler}
          data-testid="overview_exceptions"
        >
          <MdOpenInNew size={IconButton_IconSizes.small} />
          Overview
        </Button>
        {templateOrCalculation.type === 'Template' && (
          <Button
            $colorVariant="ghost"
            onClick={openModalHandler}
            data-testid="edit_playground"
            disabled={!isConfigurationEditable}
          >
            <MdEdit size={IconButton_IconSizes.small} />
            Adjust scope
          </Button>
        )}
      </ActionsBar>
    );
  }, [
    isConfigurationEditable,
    openModalHandler,
    openStoreOverviewModalHandler,
    templateOrCalculation.type,
  ]);

  return (
    <Section
      header="General configuration"
      headerActions={headerActions}
      $backgroundColor="transparent"
      showBulletPoint={false}
      $ratio={0}
    >
      {scope && (
        <ScopeDefinition
          scopeId={scope.id}
          viewMode={ViewMode.GENERAL_CONFIGURATION}
          disabled={!isConfigurationEditable}
          templateOrCalculation={templateOrCalculation}
        />
      )}
    </Section>
  );
};

export default PlaygroundDefinition;
